import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";

// OBTENER POSICIONES

export const getSecciones= async () => {
    const result = await PublicInterceptor(`Secciones`, 'GET');
    return result;
}

export const getSeccionesDistincToken = async (token) => {
    const result = await PublicInterceptor(`secciones/seccionesDistinc`, 'GET');
    return result;
}